function asArray(value) {
    return Array.isArray(value) ? value : [];
}

function formatPrice(value) {
    var numberValue = Number(value);
    return isNaN(numberValue) ? "0.00元" : numberValue.toFixed(2) + "元";
}

function getArrow(value) {
    if (value === "gt") {
        return "↑";
    }
    if (value === "lt") {
        return "↓";
    }
    return "–";
}

function collectNames(list) {
    return asArray(list).map(function(item) {
        return item && item.name ? String(item.name).replace(/^\s+|\s+$/g, "") : "";
    }).filter(Boolean);
}

function normalizeText(value) {
    if (value === undefined || value === null) {
        return "";
    }

    return String(value).replace(/^\s+|\s+$/g, "");
}

function getVisibleMeals(tjcData) {
    return asArray(tjcData).slice(0, 3).map(function(item, index) {
        var mealMap = ["breakfast", "lunch", "dinner"];
        var nameMap = ["早餐", "中餐", "晚餐"];
        return {
            mealKey: mealMap[index],
            mealName: item && item.name ? item.name : nameMap[index],
            mealLabel: (item && item.name ? item.name : nameMap[index]) + "(" + formatPrice(item && item.price) + ")",
            changeText: "价格变化 " + getArrow(item && item.compareIncreaseDecrease),
        };
    });
}

function buildOneWeekUnifiedMealSections(input) {
    var infos = asArray(input && input.infos);
    var visibleMeals = getVisibleMeals(input && input.tjcData);
    var listKeyMap = {
        breakfast: "breakfastList",
        lunch: "lunchList",
        dinner: "dinnerList",
    };
    var manualKeyMap = {
        breakfast: "brekkerMenuName",
        lunch: "lunchMenuName",
        dinner: "supperMenuName",
    };

    return infos.map(function(infoItem, index) {
        var rows = visibleMeals.reduce(function(result, meal) {
            var manualText = normalizeText(infoItem && infoItem[manualKeyMap[meal.mealKey]]);
            var names = collectNames(infoItem && infoItem[listKeyMap[meal.mealKey]]);
            var contentText = manualText || names.join("、");

            if (!contentText) {
                return result;
            }

            result.push({
                rowKey: [infoItem && infoItem.startDate || "", index, meal.mealKey].join("-"),
                mealKey: meal.mealKey,
                mealLabel: meal.mealLabel,
                changeText: meal.changeText,
                contentText: contentText,
            });

            return result;
        }, []);

        if (!rows.length) {
            return null;
        }

        return {
            sectionKey: [infoItem && infoItem.startDate || "", infoItem && infoItem.endDate || "", index].join("-"),
            sectionHeader: {
                startDate: infoItem && infoItem.startDate ? infoItem.startDate : "",
                endDate: infoItem && infoItem.endDate ? infoItem.endDate : "",
            },
            rows: rows,
        };
    }).filter(Boolean);
}

module.exports = {
    buildOneWeekUnifiedMealSections: buildOneWeekUnifiedMealSections,
    formatPrice: formatPrice,
    getArrow: getArrow,
};
